import React, {Component} from 'react';
import {BigButtonTool} from "../../../toolsSpace/oneLineToolSpace";
import storyImportIcon from "./storyImport.png";
import BaseComponent from "../../../../../base/BaseComponent";
import {permissionCheck, uuid} from "../../../../../utils";
import $ from 'jquery'
import contentHandle from "../../../util/content/contentHandle";
import MedialSelect from "../../../toolsSpace/tools/components/medialSelect";
import wordImport from "./wordImport.png";
import resourceImport from "./resourceImport.png";
import ResourceImport from "./components/resourceImport";
import {Icon} from "antd";
import {message} from "../../../../sysManagement/utils/sysManagementUtils";
import resourceSystemIcon from "../../../toolsSpace/tools/resourceSystemTool/resourceSystem.png";

class StoryImport extends BaseComponent {

    state = {
        isHover: "none",
        modalKey:uuid(),
    };

    id = uuid();
    wordKey = uuid();

    dynamicRenderFileInput = ()=>{
        this.wordKey = uuid();
        let that = this;
        $(`#${this.id}`).find("[name='wordFile']").change(function(){
            that.wordImport(this.files[0]);
        });
        $(`#${this.id}`).find("[name='wordFile']").click();
    };


    removeStyleDom = (html) => {
        // 处理html标签
        html = html.replace(/html/g,'rmt_html').replace(/head/g,'rmt_head').replace(/body/g,'rmt_body');
        // 创建虚拟的父元素并将HTML内容作为子元素
        const $parent = $("<div>").html(html);
        // 获取所有style标签的内容
        let styles = $parent.find("style").text();
        if(styles?.length) {
            styles = styles.replace(/\n/g,'');
        } else {
            return html
        }
        // 移除所有style标签
        $parent.find("style").remove();
        $parent.find("title").remove();
        let styleArr = styles.split('}');
        styleArr?.length && styleArr.forEach(style=>{
            if(style) {
                let c = style.split('{');
                if(c.length === 2) {
                    let cla = c[0];
                    let css = c[1];
                    if(cla && css) {
                        if($parent.find(cla)) {
                            $parent.find(cla).attr("style", function (index, oldStyle) {
                                return  "" + css + (oldStyle || "");
                            });
                        }
                    }
                }
            }
        });
        // 获取处理后的HTML
        let processedHtml = $parent.html();
        // 处理html标签
        processedHtml = processedHtml.replace(/rmt_html/g,'html').replace(/rmt_head/g,'head').replace(/rmt_body/g,'body');
        return processedHtml
    };

    wordImport = (file)=>{
        if(!file){
            return;
        }
        let fd = new FormData();
        fd.append("multipartFile", file);
        this.request({
            url:"/cm-sites-pms/ueditor/wordInput",
            contentType:"upload",
            method:"post",
            body:fd,
            callBack:(data)=>{
                if(data && data.includes("<style")) {
                    // 过滤style标签
                    data = this.removeStyleDom(data);
                }
                let srcList = [];
                $(`<div>${data}</div>`).find("img").each(function(){
                    let src = $(this).attr("src");
                    if(src){
                        srcList.push(src);
                    }
                });
                let fun = (picList)=>{
                    this.wordKey = uuid();
                    // 存在导入的word每一段外面都是div，但是没有最外层div，所以这里暂不能直接去掉最外层div
                    // let handleNames = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("editor.content.word.import.after.handler.names", 'removeTopDiv,changeImage');
                    let handleNames = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("editor.content.word.import.after.handler.names", 'removeTopDivMore,changeImage,removeA');
                    let handleNamesArr = handleNames.split(",");
                    // 因jq无法解析html和body标签，所以这里将相关标签进行转移
                    handleNamesArr.unshift("addHtmlAndBody");
                    // 结束时对html和body进行还原
                    handleNamesArr.push("removeHtmlAndBody");
                    let content = contentHandle(handleNamesArr, data, picList);
                    this.props.editor.setContent(content);
                    let information = this.props.editor.getInformation(false);
                    this.props.editor.setCurrentInformation({...information, title: file?.name ? file.name.replace(/(.*)\.[^\.]+/, "$1") : ""});
                    window.loading.hide();
                    this.setState({});
                };
                if(srcList.length === 0){
                    fun([]);
                }else{
                    window.loading.show(true);
                    this.request({
                        url: "/storage/getStorageFileListByUrls",
                        body:{
                            urls: srcList.join(",")
                        },
                        method:"post",
                        loading:false,
                        callBack:(picList)=>{
                            fun(picList);
                        }
                    });
                }
            },
            errorCallBack: (e) => {
                console.log(e.toString());
            },
            serverVerify: {
                serverErrorCallBack: (e) => {
                    message.warn(e);
                    console.log(e.toString());
                },
                isShowErrorMsg: false
            },
        })
    };

    render() {
        return (<>
            <div id={`${this.id}`} style={{position:'relative'}}
                 onMouseOver={() => this.setState({isHover: "block"})}
                 onMouseLeave={() => this.setState({isHover: "none"})}
                 onClick={()=>{this.setState({isHover: "none"})}}
            >

                <input key={this.wordKey} type={"file"} style={{display:"none"}} name={"wordFile"} accept={".doc,.docx"} />

                <BigButtonTool onClick={()=>{
                    this.dynamicRenderFileInput();
                }} float={this.props.float} style={this.props.style} src={storyImportIcon} text={<span>稿件导入<Icon type="caret-down" /></span>} imgWidth={this.props.width} />
                {/*word下拉*/}
                <div style={{
                    position: 'absolute',
                    top: 62,
                    left: -70,
                    zIndex: 1000,
                    display: this.state.isHover
                }}>
                    <MedialSelect >
                        <div className={'selectList'} onClick={()=>{
                            this.dynamicRenderFileInput();
                        }} style={{width:'119px',height:'32px',padding:'0 10px',lineHeight:"32px"}}>
                            <img src={wordImport} style={{marginRight:"8px"}}/>
                            <span>word导入</span>
                        </div>

                            {permissionCheck('right_to_use_zyk')?  <div className={'selectList'} style={{width:'119px',height:'32px',padding:'0 10px',lineHeight:"32px"}}
                                                                        onClick={(e)=>{
                                                                            this.resourceImportOpen()
                                                                        }}>
                                <img src={resourceImport} style={{marginRight:"8px"}}/>
                                <span>资源库导入</span>
                            </div>:null}


                    </MedialSelect>
                </div>
            </div>
                <ResourceImport key={this.state.modalKey} ref={(e)=>this.resourceImport=e} onCloseCall={()=>{this.setState({modalKey:uuid()})}} editor={this.props.editor}/></>
        );
    }
    resourceImportOpen(){
        this.resourceImport.showModal()
    }
}

export default StoryImport;